import type { DashboardMode } from "@/lib/dashboard-mode";

export type Workload = {
  appointments: Record<string, number>;
  labWorks: Record<string, number>;
};

export type WorkloadChip = { key: string; label: string };

/** Papéis que podem ser o profissional de uma consulta — mesma regra de
 *  `organization.listDentists` (packages/api/src/routers/organization.ts), que é quem popula o
 *  seletor "Profissional" da agenda. Fora dessa lista, a coluna mostra "—" em vez de um zero que
 *  leria como "não produz" pra quem nem pode receber consulta (recepção, assistente). */
const APPOINTMENT_ROLES = ["DENTIST", "OWNER", "PARTNER"];

/** Chips de carga aberta de um membro. Array vazio = mostrar "—" (não elegível a nenhum tipo de
 *  carga no(s) tipo(s) da organização). No laboratório todo membro ativo pode receber delegação
 *  (ver prosthesis.assignService), então lá o zero é informação legítima — "está livre". */
export function getWorkloadChips(
  role: string,
  userId: string,
  mode: DashboardMode,
  workload: Workload | undefined,
): WorkloadChip[] {
  if (!workload) return [];
  const chips: WorkloadChip[] = [];

  if (mode !== "lab" && APPOINTMENT_ROLES.includes(role)) {
    const n = workload.appointments[userId] ?? 0;
    chips.push({ key: "appointments", label: `${n} consulta${n === 1 ? "" : "s"}` });
  }

  if (mode !== "office") {
    const n = workload.labWorks[userId] ?? 0;
    chips.push({ key: "labWorks", label: `${n} trabalho${n === 1 ? "" : "s"}` });
  }

  return chips;
}

export const WORKLOAD_COLUMN_HINT: Record<DashboardMode, string> = {
  office: "Consultas de hoje em diante que ainda não foram concluídas ou canceladas.",
  lab: "Serviços delegados ao membro que ainda não saíram de produção.",
  hybrid:
    "Consultas de hoje em diante ainda não concluídas e serviços delegados ainda em produção.",
};
